import React from 'react'

interface ContentLayoutProps {
  children: React.ReactNode
  variant?: 'full' | 'default'
}

const ContentLayout: React.FC<ContentLayoutProps> = ({ children, variant = 'default' }) => {
  // full: no padding, no width constraint (workout routes — layout handled by page components)
  if (variant === 'full') {
    return (
      <div className="w-full">
        {children}
      </div>
    )
  }

  // default: replicates Semantic UI Grid.Column responsive widths
  // mobile/tablet (<992px): 100% width + 1rem padding
  // computer (>=992px): 75% (12/16)
  // largeScreen (>=1200px): 68.75% (11/16)
  // widescreen (>=1920px): 56.25% (9/16)
  return (
    <div className="w-full px-4 mx-auto min-[992px]:max-w-[75%] min-[1200px]:max-w-[68.75%] min-[1920px]:max-w-[56.25%]">
      {children}
    </div>
  )
}

export default ContentLayout
